module.exports = __webpack_public_path__ + "static/media/growShrinkButton.e913e16e.png";